module.exports = __webpack_public_path__ + "img/company-update.a02f2700.png";